export default class Link {
    id
    renderer
    
    constructor(id, renderer) {
        this.id = id;
        this.renderer = renderer;
    }
}